import styled from 'styled-components';
import { Button as ButtonBase } from '../../input/Button';
import { Flex } from '../../layout/Flex';

export const Wrapper = styled(Flex).withConfig({ displayName: 'Wrapper' }).attrs({
    width: '100%',
    padding: 0.5,
    borderRadius: 3,
    overflow: 'hidden',
})``;

export const Button = styled(ButtonBase).withConfig({ displayName: 'Button' }).attrs({
    variant: 'transparent',
    width: '100%',
    size: 'l',
    spacing: 2,
    padding: '0 8px',
    flexShrink: 0,
    justifyContent: 'flex-start',
    borderRadius: '20px',
})`
    background-color: var(--background-secondary);
    color: var(--color-secondary);

    &:hover,
    &:focus,
    &:active,
    &.active {
        color: var(--color-primary);
    }
`;
